import { render } from "./MapLogoSvg.vue?vue&type=template&id=41567d42"
import script from "./MapLogoSvg.vue?vue&type=script&lang=js"
export * from "./MapLogoSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__